import React from 'react'
import { useUserRedux } from '@hooks'
import Selector from './Selector'

const TableSelector = ({ items, value, onChange, containerClassName }) => {
    const { tableId } = useUserRedux()

    return (
        <Selector
            value={value || tableId}
            options={items || []}
            onChange={onChange}
            textHeader="Table No."
            textPlaceholder="Select Table No."
            containerClassName={containerClassName}
            isSearchable={false}
        />
    )
}

export default TableSelector
